import React from "react";

const WordTriesCard = ({
  className,
  wordTries,
  getAttemptCount,
  module = "fail",
}) => {
  const lastWord = wordTries[wordTries?.length - 1];

  return (
    <div
      className={`${className} border-[0.8px] border-[#434343]  w-full rounded-xl px-4 py-3 text-[11px] bg-[#0e0e0e]`}
    >
      <h2 className="text-[#f9f9f9]">Attempts</h2>
      <div className="flex flex-col gap-y-1 w-full mt-2">
        {wordTries?.map((word, index) => {
          return (
            <div className="flex w-full items-center justify-between text-[11px]">
              <span className="text-[#9d9d9d]">{getAttemptCount(index)}</span>
              <p
                className={`${
                  word === lastWord && module === "win" && "text-green-600"
                } font-semibold text-xs `}
              >
                {word}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WordTriesCard;
